import { createSlice } from "@reduxjs/toolkit";
import { KYC_STATUS_VARIANTS } from "constants/kycStatusVariants";

// This slice holds customer details of user who is doing KYC verification

export interface IGenericInformation {
  customerId: string;
  ownerName: string;
  shopName: string;
  mobileNumber: string;
  establishmentType: string;
  panDetails: PanDetails;
  bankDetails: BankDetails;
  gstDetails?: GstDetails;
  kycStatus: (typeof KYC_STATUS_VARIANTS)[keyof typeof KYC_STATUS_VARIANTS];
  /** True when an active VERIFIED KYC exists (including during bank re-KYC). */
  hasVerifiedActive?: boolean;
}

export interface GstDetails {
  gstNumber?: string;
  gstStatus?: string;
  registeredBusinessName?: string;
  stateOfRegistration?: string;
  businessType?: string;
  kycVendorName?: string;
  gstDocumentKey?: string;
}

export interface BankDetails {
  id: number;
  accountType: string;
  bankAccountNumber: string;
  bankName: string;
  bankAddress: string;
  bankTransactionRefNo: string;
  branchName: string;
  accountHolderName: string;
  userProvidedName: string | null;
  ifscCode: string;
  userNameMatchScore: string;
  nameMatched?: boolean;
  accountProofDocumentUrl?:string;
}

export interface PanDetails {
  id: number;
  fullName: string;
  panNumber: string;
  panValidityStatus: string;
  panOperationalStatus: string;
  panIdHolderTitle: string;
  isCompliant: boolean;
  panAadhaarLinkStatus: string;
  uploadedDocumentKey?: string;
}

const GenericInformation = createSlice({
  name: "info",
  initialState: {
    kycDone: false,
    allData: {
      customerId: "",
      ownerName: "",
      shopName: "",
      mobileNumber: "",
      establishmentType: null,
      panDetails: null,
      bankDetails: null,
      kycStatus: KYC_STATUS_VARIANTS.PENDING,
    },
  },
  reducers: {
    setGenericInformation: (state, action) => {
      state.allData = {
        ...state.allData,
        ...action.payload,
      };
    },
    setKycDone: (state, action) => {
      state.kycDone = action.payload as boolean;
    },
  },
});

// Export actions and reducer
export const { setGenericInformation, setKycDone } = GenericInformation.actions;
export default GenericInformation.reducer;
